import './App.css';
import React, { useState } from 'react';
import Main from './pages/Main'
import Particles from "react-tsparticles";
import "./styles.css";


function App() {

  return (
    <div>
      <Main/>
    </div>
  );
}

export default App;